export type PricingGroupBy = "partNumbers" | "vehicles";

export type PricingGroupOrder = "widestPrices" | "mostParts";

export enum PricingAlignTarget {
  Lowest = 0,
  Average = 1,
  Custom = 2,
  Intelligent = 3,
  GradeMarkdown = 4,
  LastSold = 5,
  LastSoldGradeMarkdown = 6,
  AverageSold = 7,
  AverageSoldGradeMarkdown = 8,
}

export enum PricingMemberKind {
  Listed = 0,
  Stock = 1,
}

export interface IPricingGroupFigures {
  listedCount: number;
  stockCount: number;
  totalCount: number;
  listedMinPrice: number | null;
  listedMaxPrice: number | null;
  stockMinPrice: number | null;
  stockMaxPrice: number | null;
  minPrice: number | null;
  maxPrice: number | null;
  averagePrice: number | null;
  spread: number;
  averageSoldPrice: number | null;
  soldCount: number;
  grades: string[];
  intelligenceAverage: number | null;
  lastIntelligenceLookup: string | null;
  intelligenceCount: number;
}

export interface IPricingGroupByPartNumber extends IPricingGroupFigures {
  partNumber: string;
  categoryId: string | null;
  categoryName: string | null;
}

export interface IPricingGroupByVehicle extends IPricingGroupFigures {
  make: string;
  model: string;
  generation: string | null;
  yearFrom: number | null;
  yearTo: number | null;
  categoryId: string;
  categoryName: string | null;
}

export interface IPricingGroupsResponse {
  byPartNumber: IPricingGroupByPartNumber[];
  byVehicle: IPricingGroupByVehicle[];
}

export interface IPricingMembersRequest {
  partNumber?: string | null;
  vehicleMake?: string | null;
  vehicleModel?: string | null;
  vehicleGeneration?: string | null;
  categoryId?: string | null;
}

export interface IPricingMember {
  partId: string;
  tagNumber: string | null;
  title: string | null;
  photoUrl: string | null;
  grade: string | null;
  vehicleMake: string | null;
  vehicleModel: string | null;
  vehicleYear: number | null;
  categoryName: string | null;
  kind: PricingMemberKind;
  currentPrice: number | null;
  offerId: string | null;
  partNumber: string | null;
  oePartNumber: string | null;
  otherPartNumbers: string | null;
  internalComment: string | null;
  intelligenceAverage: number | null;
  lastIntelligenceLookup: string | null;
  lastPartLookupChecked: string | null;
  partsLookupRequestId: string | null;
  categoryUcid: string | null;
  listedOn: string | null;
  created: string | null;
  lastSoldPrice: number | null;
  lastSoldOn: string | null;
}

export interface IPricingAlignRequest {
  partIds: string[];
  target: PricingAlignTarget;
  customPrice?: number | null;
}

export interface IPricingAlignFailure {
  partId: string;
  reason: string;
}

export interface IPricingAlignResponse {
  price: number;
  applied: number;
  skipped: number;
  failed: number;
  failures: IPricingAlignFailure[];
}

export type PricingGroupKey =
  | { type: "partNumber"; partNumber: string }
  | { type: "vehicle"; make: string; model: string; generation: string | null; categoryId: string };
